import {
  VIEWER_GLASS_SURFACE_STYLE,
  VIEWER_INFO_PANEL_INLINE_OFFSET,
  VIEWER_TOP_CONTROL_OFFSET,
} from './viewerLayout';

export function ViewerInfoPanel({ children, onClose }) {
  return (
    <>
      <div
        className="absolute inset-0 z-10"
        onClick={onClose}
        data-testid="info-panel-backdrop"
      />

      <div
        className="absolute z-20 flex items-center gap-2 viewer-info-slide"
        style={{
          top: VIEWER_TOP_CONTROL_OFFSET,
          left: VIEWER_INFO_PANEL_INLINE_OFFSET,
        }}
        onClick={(event) => event.stopPropagation()}
        data-testid="info-panel"
      >
        {children}
      </div>
    </>
  );
}

export function ViewerInfoChip({ children, ...rest }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-home-16 text-text-primary font-sans font-semibold"
      style={{
        ...VIEWER_GLASS_SURFACE_STYLE,
        height: 32,
        minWidth: 64,
        paddingLeft: 14,
        paddingRight: 14,
        fontSize: 14,
        lineHeight: '16px',
      }}
      {...rest}
    >
      {children}
    </span>
  );
}
